import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { arrToObject } from 'utils/functional';

type Level = Readonly<{
  id: string;
  name: string;
}>;

export function levelOptions(levels: ReadonlyArray<Level>): Array<string> {
  return levels.map((level) => level.id);
}

export function levelOptionTitles(
  levels: ReadonlyArray<Level>,
): Record<string, string> {
  return arrToObject(levels.map((l) => [l.id, l.name]));
}

export function hasLocation(s: SearchLocation | null | undefined): boolean {
  // @ts-expect-error TS(2322): Type 'boolean | null | undefined' is not assignabl... Remove this comment to see the full error message
  return s && s.hasGeo;
}

export function isLocationEmpty(s: SearchLocation | null | undefined) {
  if (!s) return true;

  const { hasGeo, ...rest } = s;

  return Object.values(rest).every((o) => o === null) && !hasGeo;
}
